import axios from 'axios'
import qs from 'qs'
import router from '@/router'
import store from '@/store'

axios.interceptors.request.use((request) => {
  request.headers['X-CSRF-Token'] = store.getters.getCsrfToken
  const authToken = store.getters.getAuthToken
  if (authToken) {
    request.headers.Authorization = `Bearer ${authToken}`
  }
  return request
})

axios.interceptors.response.use((response) => {
  store.dispatch('setCsrfToken', response.headers['x-csrf-token'])
  return response
},
(error) => {
  const errorResponse = error.response ? error.response : error
  console.log(errorResponse)

  if (errorResponse.headers) {
    store.dispatch('setCsrfToken', errorResponse.headers['x-csrf-token'])
  }

  if (errorResponse.status === 401) {
    store.dispatch('setAuthToken', null)
    if (!errorResponse.config.url.includes('/login')) {
      router.replace({name: 'login'})
    }
  }
  return Promise.reject(error)
})

const appHost = process.env.VUE_APP_HOST
const axiosHost = appHost && appHost !== '' ? appHost : window.location.host
axios.defaults.baseURL = process.env.VUE_APP_PROTOCOL + '://' + axiosHost + process.env.VUE_APP_CONTEXT
axios.defaults.withCredentials = true
axios.defaults.hostURL = process.env.VUE_APP_PROTOCOL + '://' + axiosHost
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.paramsSerializer = (params) => {
  return qs.stringify(params)
}

export default axios
